import { useFormContext, useFormField } from '@calendly/form';
import { BrandLogo } from '@calendly/ui/components/brand-logo';
import { Button } from '@calendly/ui/components/button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ArrowChevronDownMiniIcon } from '@calendly/ui/components/icons';
import { Item, PopupDropdownMenu, Group, GroupTitle } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { logoName } from './config';
import { SendFromOption } from './send_from_option';
import { FieldBlock } from './styles';
const sendContainerCss = "sazzdmy";
const SendContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sendContainerCss, props.className)} />;
});
const emailAddressCondensedCss = "e1xztvn5";
const EmailAddressCondensed = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(emailAddressCondensedCss, props.className)} />;
});
const styledLogoCss = "s1beitge";
const StyledLogo = forwardRef((props, ref) => <BrandLogo ref={ref} {...props} className={classNames(styledLogoCss, props.className)} />);
const senderWrapperCss = "s12d21b9";
const SenderWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(senderWrapperCss, props.className)} />;
});
const fromTextCss = "fyzy4tu";
const FromText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(fromTextCss, props.className)} />;
});
const styledButtonCss = "sd38m97";
const StyledButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);
const fieldBlockNoSidePaddingCss = "fb4o23";
const FieldBlockNoSidePadding = forwardRef((props, ref) => <FieldBlock ref={ref} {...props} className={classNames(fieldBlockNoSidePaddingCss, props.className)} />);
export const SendWithField = ({
  emails,
  ...props
}) => {
  const [{
    name
  }] = useFormField(props);
  const {
    setFieldValue
  } = useFormContext();
  const [toggleDropdown, Dropdown] = useDropdown();
  const initialSelectedEmail = emails.length > 1 ? emails[1] : emails[0];
  const [selectedEmail, setSelectedEmail] = useState(initialSelectedEmail);
  const hasGmailConnected = emails.some(email => email.type === 'gmail');
  const hasOutlookConnected = emails.some(email => email.type === 'outlook');
  const handleClickEmail = option => {
    setSelectedEmail(option);
    setFieldValue(name, {
      type: option.type,
      email: option.emailAddress
    });
    toggleDropdown();
  };
  return <FieldBlockNoSidePadding data-component="send_with_field_block">
      <SendContainer>
        <Dropdown>
          <PopupDropdownMenu>
            {emails.map(option => <Item key={option.emailAddress} onClick={() => {
            handleClickEmail(option);
          }}>
                <SendFromOption {...option} />
              </Item>)}
            {(!hasGmailConnected || !hasOutlookConnected) && <Group>
              <GroupTitle>
                CONNECT YOUR EMAIL
              </GroupTitle>
              {!hasGmailConnected && <Item href="https://calendly.com/integrations/gmail" target="_blank" rel="noreferrer">
                <StyledLogo name={logoName.gmail} />
                <p> Gmail </p>
              </Item>}
              {!hasOutlookConnected && <Item href="https://calendly.com/integrations/outlook" target="_blank" rel="noreferrer">
                <StyledLogo name={logoName.outlook} />
                <p> Outlook </p>
              </Item>}
            </Group>}
          </PopupDropdownMenu>
        </Dropdown>
        <SenderWrapper>
          <FromText> From: </FromText>
          <StyledButton decoration="ghost" onClick={toggleDropdown}>
            <StyledLogo name={logoName[selectedEmail.type]} />
            <EmailAddressCondensed>{selectedEmail.emailAddress}</EmailAddressCondensed>
            <ArrowChevronDownMiniIcon />
          </StyledButton>
        </SenderWrapper>
      </SendContainer>
    </FieldBlockNoSidePadding>;
};

require("./send_with.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./send_with.js");